import { UserGroupIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { createEarlyAdopterHandler } from '@/utils/earlyAdopterInterceptor';
import { Link } from 'react-router-dom';

const PricingCTA = () => {
  const { openModal } = useEarlyAdopter();

  return (
    <div className="text-center">
      <Card className="max-w-2xl mx-auto bg-gradient-to-br from-primary/5 to-circle-secondary/5 border-primary/20">
        <CardContent className="pt-8 pb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <UserGroupIcon className="w-8 h-8 text-primary" />
            <h3 className="text-2xl font-bold text-foreground">
              Ready to Start Thriving, Together?
            </h3>
          </div>
          <p className="text-muted-foreground mb-6 leading-relaxed">
            Join thousands of families using SeniorThrive to stay safer, connected, and thriving at home.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-primary hover:bg-black/50"
              onClick={createEarlyAdopterHandler(openModal, 'Pricing CTA - Request Early Access')}
            >
              Get Early Access
              <ArrowRightIcon className="w-4 h-4 ml-2" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              asChild
            >
              <Link to="/contact">
                Contact Our Team
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PricingCTA;